'use client';

import { useSelector } from 'react-redux';

import CalendarSearch from '@/components/calendar/calendar-search';
import EventCardsDesktop from '@/components/event-cards/event-cards-desktop';
import useEventCards from '@/components/event-cards/use-event-cards';
import { selectEventsLoading } from '@/store/calendar-events/calendar-events.selectors';
import { WithLang } from '@/types/general';

import CalendarFiltersDesktop from './calendar-filters.desktop';
import CalendarRuler from './calendar-ruler';
import { useCalendar } from './use-calendar';
import { useFilters } from './use-filters';

export default function CalendarDesktop(props: WithLang) {
    const {
        filtersAvailable,
        filtersSelected,
        filtersSelectedCount,
        handleAddFilter,
        handleRemoveFilter,
        handleResetFilters,
    } = useFilters();

    const loading = useSelector(selectEventsLoading);

    const {
        notFoundContext,
        events,
        toggleSearchRangeOff,
        toggleSearchRangeOn,
        onSearchChange,
        sortByScore,
        sortByDate,
        onSearchSubmit,
        onSearchClear,
        searchArgs,
        withSearch,
    } = useEventCards();

    const { todayHandler, selectedDays, handleSelectRange } = useCalendar();

    return (
        <>
            <CalendarSearch
                onSearchClear={onSearchClear}
                selectedDays={selectedDays}
                events={events}
                toggleSearchRangeOff={toggleSearchRangeOff}
                toggleSearchRangeOn={toggleSearchRangeOn}
                onSearchChange={onSearchChange}
                sortByScore={sortByScore}
                sortByDate={sortByDate}
                onSearchSubmit={onSearchSubmit}
                searchArgs={searchArgs}
                lang={props.lang}
            />
            <CalendarFiltersDesktop
                lang={props.lang}
                filtersAvailable={filtersAvailable}
                filtersSelected={filtersSelected}
                filtersSelectedCount={filtersSelectedCount}
                handleAddFilter={handleAddFilter}
                handleRemoveFilter={handleRemoveFilter}
                onReset={handleResetFilters}
            />
            <CalendarRuler
                isHidden={Boolean(searchArgs.searchString) && !Boolean(searchArgs.ranged)}
                selectedDays={selectedDays}
                lang={props.lang}
                onSelectDays={handleSelectRange}
                todayHandler={todayHandler}
            />
            <EventCardsDesktop
                withDates={!withSearch || !Boolean(searchArgs.sortByScore)}
                notFoundContext={notFoundContext}
                isLoading={loading}
                events={events}
                lang={props.lang}
            />
        </>
    );
}
